<template>
  <div id="aboutEbid">
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header class="panel-header" slot="header">
          <span slot="title">关于我们</span>
        </eb-panel-header>
        <div slot="body">
          <p>易比得合规采购云（www.360bid.cn）为企业提供电子采购、合规鉴证和供应链管理等专业服务。因其合规、便捷和安全的特性，易比得的服务和产品已被信息安全、轨道交通、保险证券等多个行业的知名企业所采用。</p>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header class="panel-header" slot="header">
          <span slot="title">联系我们</span>
        </eb-panel-header>
        <div slot="body">
          <p>易比得愿意随时倾听您的建议和意见，请通过以下方式与我们联系：</p>
          <p>客服电话：186-1400-5157</p>
          <p>客服微信：小易</p>
          <div><img class="xiaoyi" :src="$ebConfig.imgPath+'img/xiaoyi.jpeg'"></div>
          <p>微信公众号：微信搜索“易比得”，关注并留言</p>
          <p>我们会及时对您的留言进行回复。</p>
          <div><img :src="$ebConfig.imgPath+'img/gongzhonghao_ybd.jpg'"></div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header class="panel-header" slot="header">
          <span slot="title">商家入驻</span>
        </eb-panel-header>
        <div slot="body">
          <p> 目前易比得已开放供应商自注册入口。供应商在易比得主页选择“注册”，按步骤提交相关资料，即可完成注册。为提高中选概率，易比得建议供应商申请实名认证。</p>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header class="panel-header" slot="header">
          <span slot="title">广告合作</span>
        </eb-panel-header>
        <div slot="body">
          <p> 如有广告合作意向，请与易比得客服联系，186-1400-5157。</p>
        </div>
      </eb-panel>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'aboutEbid',
  components: {
    ebPanel,
    ebPanelHeader
  },
  created() {
    this.$root.layout.isLoading = false;
  },
  mounted() {
    this.setOffsetTop();
  },
  methods: {
    setOffsetTop: function() {
      setTimeout(() => {
        let info = this.$route.params.info;
        $('html,body').scrollTop(0);
        if (info === 'aboutUs') {
          $('html,body').scrollTop(0);
        } else if (info === 'contactUs') {
          $('html,body').scrollTop(240);
        } else if (info === 'merchantEntry') {
          $('html,body').scrollTop(1500);
        } else if (info === 'advertisingService') {
          $('html,body').scrollTop(1500);
        }
      }, 10);
    }
  },
  watch: {
    $route: function() {
      this.setOffsetTop();
    }
  }
};
</script>
<style scoped lang="less">
#aboutEbid {
  .xiaoyi {
    width: 255px;
  }
}
</style>
